export function underScore(input: string): string {
  let result = input.replace(/([A-Z])/g, $1 => `_${$1}`.toLowerCase());
  if (result.startsWith('_')) {
    result = result.substr(1);
  }
  return result;
}



// WEBPACK FOOTER //
// ./app/javascript/utils/string_utils.ts